module.exports = __webpack_public_path__ + "img/11.1843280d.png";